import { Card, CardContent } from "@/components/ui/card";
import { useNossaHistoria } from "@/hooks/useNossaHistoria";
import { Skeleton } from "@/components/ui/skeleton";

export function Timeline() {
  const { timelineEvents, timelineLoading } = useNossaHistoria();

  if (timelineLoading) {
    return (
      <div className="space-y-8">
        {[1, 2, 3, 4].map((i) => (
          <Skeleton key={i} className="h-32 w-full" />
        ))}
      </div>
    );
  }

  return (
    <div className="relative">
      {/* Timeline line */}
      <div className="absolute left-4 sm:left-8 top-0 bottom-0 w-0.5 bg-green-200"></div>
      
      <div className="space-y-8">
        {timelineEvents?.map((event, index) => (
          <div key={index} className="relative flex items-start">
            {/* Timeline dot */}
            <div className="absolute left-2 sm:left-6 w-4 h-4 bg-green-600 rounded-full border-4 border-white shadow-md z-10"></div>
            
            {/* Content */}
            <div className="ml-12 sm:ml-20 flex-1">
              <Card className="hover:shadow-lg transition-shadow">
                <CardContent className="p-4 sm:p-6">
                  <div className="mb-2">
                    <span className="inline-block bg-green-100 text-green-800 text-sm font-medium px-3 py-1 rounded-full">
                      {event.year}
                    </span>
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold mb-2 text-gray-800">
                    {event.title}
                  </h3>
                  <p className="text-gray-600 mobile-text leading-relaxed">
                    {event.description}
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}